import { render, staticRenderFns } from "./EventManagement.vue?vue&type=template&id=036a425c"
import script from "./EventManagement.vue?vue&type=script&lang=js"
export * from "./EventManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports